export default {
  admission: "پذیرش",
  unitAdmission: "پذیرش واحد",
  todayReceptions: "پذیرش‌های معلق",
  homePage: "صفحه‌ی اصلی",
  usersList: "لیست کاربران",
  servicePage: "صفحه خدمات",
  addUser: "افزودن کاربر",
  doctorsList: "لیست پزشکان",
  patientsList: "لیست بیماران",
  managePatients: "لیست بیماران",
  cardboardAdmission: "کارتابل صندوق",
  addPatient: " افزودن بیمار",
  editUser: " ویرایش کاربر",
  editPatient: " ویرایش بیمار",
  addReferral: "ثبت مراجعه",
  cardBoard: "ویرایش مراجعه",
  addUserService: "افزودن خدمت",
  services: "خدمات",
  addServices: "افزودن خدمات",
  editServices: "ویرایش خدمات",
  service: "خدمت",
  section: "بخش‌ها",
  addSection: "افزودن بخش‌ها",
  editSection: "ویرایش بخش‌ها",
  unit: "واحدها",
  addUnit: "افزودن واحدها",
  editUnit: "ویرایش واحدها",
  room: "اتاق‌ها",
  addRoom: "افزودن اتاق‌",
  editRoom: "ویرایش اتاق‌",
  bed: "تخت‌ها",
  addBed: "افزودن تخت ها",
  editBed: "ویرایش تخت ها",
  discountGroups: "گروه‌های تخفیف",
  addDiscountGroups: "افزودن گروه‌های تخفیف",
  editDiscountGroups: "ویرایش گروه‌های تخفیف",
  setting: "تنظیمات",
  currency: "واحد پولی",
  addCurrency: " افزودن واحد پولی",
  editCurrency: " ویرایش واحد پولی",
  medicalRecordTabs: "پرونده پزشکی",
  postReferrals: "مراجعات پیشین",
  medicalRecords: "پزشکی",
  baseInformation: "اطلاعات پایه",
  userRelated: "مرتبط با کاربر",
  structure: "زیرساخت مرکز",
  familyRelationships: "نسبت‌های فامیلی",
  addFamilyRelationships: " افزودن نسبت‌های فامیلی",
  editFamilyRelationships: "ویرایش نسبت‌های فامیلی",
  bloodTypes: "گروه خونی",
  addBloodTypes: "افزودن گروه خونی",
  editBloodTypes: "ویرایش گروه خونی",
  cyclePains: "cycle Pains",
  addCyclePains: "add cycle Pains",
  editCyclePains: "new cycle Pains",
  contraceptives: "روشهای پیشگیری‌از‌بارداری",
  addContraceptives: "افزودن روشهای پیشگیری‌از‌بارداری",
  editContraceptives: "ویرایش روشهای پیشگیری‌از‌بارداری",
  diseases: "بیماری‌های خاص",
  addDiseases: "افزودن بیماری‌های خاص",
  editDiseases: "ویرایش بیماری‌های خاص",
  cancers: "سرطان‌ها",
  addCancers: "افزودن سرطان‌ها",
  editCancers: "ویرایش سرطان‌ها",
  surgeryCategories: "دسته‌بندی‌های جراحی",
  surgeries: " جراحی‌ها",
  sonographies: " سونوگرافی",
  radiologyTests: " رادیولوژی",
  addRadiologyTests: " افزودن رادیولوژی",
  editRadiologyTests: "ویرایش رادیولوژی",
  medications: " داروها",
  addMedications: " افزودن داروها",
  editMedications: " ویرایش داروها",
  pregnancyMethods: " روشهای بارداری",
  addPregnancyMethods: "افزودن روشهای بارداری",
  editPregnancyMethods: "ویرایش روشهای بارداری",
  parityTypes: " parity",
  addParityTypes: "add parity",
  editParityTypes: "edit parity",
  abortionTypes: "انواع سقط جنین",
  addAbortionTypes: "افزودن انواع سقط جنین",
  editAbortionTypes: "ویرایش انواع سقط جنین",
  abortionCauses: "دلایل سقط",
  addAbortionCauses: "افزودن دلایل سقط",
  editAbortionCauses: "ویرایش دلایل سقط",
  abortionMethods: "روش‌های سقط",
  addAbortionMethods: "افزودن روش‌های سقط",
  editAbortionMethods: "ویرایش روش‌های سقط",
  ivfMethods: "روش‌های ivf",
  addIvfMethods: "افزودن روش‌های ivf",
  editIvfMethods: "ویرایش روش‌های ivf",
  transferOperationTypes: "روش‌های انتقال",
  addTransferOperationTypes: " افزودن روش‌های انتقال",
  editTransferOperationTypes: "ویرایش روش‌های انتقال",
  ioMethods: "روش‌های io",
  addIoMethods: "افزودن روش‌های io",
  editIoMethods: "ویرایش روش‌های io",
  allergies: "آلرژی‌ها",
  addAllergies: "افزودن آلرژی‌ها",
  editAllergies: "ویرایش آلرژی‌ها",
  addictions: "اعتیادها",
  addAddictions: "افزودن اعتیادها",
  editAddictions: "ویرایش اعتیادها",
  financialSettings: "تنظیمات مالی",
  sectionsReception: "مدیریت بخش ها",
  receptionUnits: "واحدها",
  receptionsInRoom: " اتاق ها",
  QueueAndRoomSelection: "اتاق ها و صف پذیرش",
  patientReceptionQueue: "صف پذیرش بیمارها",
  payForReception: "پرداخت",
  sectionsManagement: "مدیریت بخش ها",
  accounting: "مالی",
  accountsHeadings: "سرفصل حسابها",
  accountGroups: "گروه حساب",
  addAccountGroups: "افزودن گروه حساب",
  editAccountGroups: "ویرایش گروه حساب",
  totalAccounts: "حساب کل",
  addTotalAccounts: "افزودن حساب کل",
  editTotalAccounts: "ویرایش حساب کل",
  unitAccounting: "حسابداری",
  subsidiaryAccounts: "حساب معین ",
  addSubsidiaryAccounts: "افزودن حساب معین ",
  editSubsidiaryAccounts: "ویرایش حساب معین ",
  detailAccount: "حساب تفصیل",
  addDetailAccount: "افزودن حساب تفصیل",
  editDetailAccount: "ویرایش حساب تفصیل",
  artificialReproductiveTechnologies: "فناوری تولید مثل مصنوعی",
  addArtificialReproductiveTechnologies: "افزودن فناوری تولید مثل مصنوعی",
  editArtificialReproductiveTechnologies: "ویرایش فناوری تولید مثل مصنوعی",
  urologyTests: " آزمایشات اورولوژی ",
  addUrologyTests: " افزودن آزمایشات اورولوژی ",
  editUrologyTests: "ویرایش  آزمایشات اورولوژی ",
  pos: " دستگاه های کارت خوان ",
  addPos: "افزودن  دستگاه های کارت خوان ",
  editPos: " ویرایش دستگاه های کارت خوان ",
  financialDocuments: " اسناد مالی ",
  accountingDocuments: " اسناد حسابداری ",
  indications: "Indications",
  addIndications: "add Indications",
  editIndications: "edit Indications",
  MedicalAbbreviationTests: "Abbreviation Tests",
  addMedicalAbbreviationTests: "add Abbreviation Tests",
  editMedicalAbbreviationTests: "edit Abbreviation Tests",
  examinationMethods: "Examination Methods",
  addExaminationMethods: "add Examination Methods",
  editExaminationMethods: "edit Examination Methods",
  examinationViews: "Examination Views",
  addExaminationViews: "add Examination Views",
  editExaminationViews: "edit Examination Views",
  cardiacActivities: "Cardiac Activities",
  addCardiacActivities: "add Cardiac Activities",
  editCardiacActivities: "edit Cardiac Activities",
  placentaLocations: "Placenta Locations",
  addPlacentaLocations: "add Placenta Locations",
  editPlacentaLocations: "edit Placenta Locations",
  impressionLocations: "Impression Locations",
  addImpressionLocations: "add Impression Locations",
  editImpressionLocations: "edit Impression Locations",
  bladderNodules: "Bladder Nodules",
  addBladderNodules: "add Bladder Nodules",
  editBladderNodules: "edit Bladder Nodules",
  uterusPositions: "Uterus Positions",
  addUterusPositions: "add Uterus Positions",
  editUterusPositions: "edit Uterus Positions",
  uterusSizes: "Uterus Sizes",
  addUterusSizes: "add Uterus Sizes",
  editUterusSizes: "edit Uterus Sizes",
  uterusAdenomyosisTests: "Adenomyosis Tests",
  addUterusAdenomyosisTests: "add Adenomyosis Tests",
  editUterusAdenomyosisTests: "edit Adenomyosis Tests",
  endometriumTests: "Endometrium Tests",
  addEndometriumTests: "Add Endometrium Tests",
  editEndometriumTests: "Edit Endometrium Tests",
  endometriumTypes: "Endometrium Types",
  addEndometriumTypes: "Add Endometrium Types",
  editEndometriumTypes: "Edit Endometrium Types",
  endometriumIsoTests: "EndometriumIsoTests",
  addEndometriumIsoTests: "add EndometriumIsoTests",
  editEndometriumIsoTests: "edit EndometriumIsoTests",
  fibroidTypes: "Fibroid Types",
  addFibroidTypes: "add Fibroid Types",
  editFibroidTypes: "edit Fibroid Types",
  polypTypes: "Polyp Types",
  addPolypTypes: "add Polyp Types",
  editPolypTypes: "edit Polyp Types",
  threeDCoronals: "ThreeD Coronals",
  addThreeDCoronals: "add ThreeD Coronals",
  editThreeDCoronals: "edit ThreeD Coronals",
  endometriomaTypes: "Endometrioma Types",
  addEndometriomaTypes: "add Endometrioma Types",
  editEndometriomaTypes: "edit Endometrioma Types",
  ovarianAdhesionTypes: "OvarianAdhesionTypes",
  addOvarianAdhesionTypes: "add OvarianAdhesionTypes",
  editOvarianAdhesionTypes: "edit OvarianAdhesionTypes",
  dopplerStudyTypes: "Doppler Study Types",
  addDopplerStudyTypes: "add Doppler Study Types",
  editDopplerStudyTypes: "edit Doppler Study Types",
  pouchDouglasTypes: "Pouch Douglas Types",
  addPouchDouglasTypes: "add Pouch Douglas Types",
  editPouchDouglasTypes: "edit Pouch Douglas Types",
  uteroSacralLigamentNoduleTypes: "Utero Sacral Ligament ",
  addUteroSacralLigamentNoduleTypes: "add Utero Sacral Ligament ",
  editUteroSacralLigamentNoduleTypes: "edit Utero Sacral Ligament ",
  rectoSigmoidNoduleTypes: "Recto Sigmoid Nodule Types ",
  addRectoSigmoidNoduleTypes: "add Recto Sigmoid Types ",
  editRectoSigmoidNoduleTypes: "edit Recto Sigmoid Types ",
  tendernessWithTheProbeTypes: "Tenderness Probe ",
  addTendernessWithTheProbeTypes: "add Tenderness Probe ",
  editTendernessWithTheProbeTypes: "edit Tenderness Probe ",
  commentTypes: "Comment Types",
  addCommentTypes: "add Comment Types",
  editCommentTypes: "edit Comment Types",
  adnexaTypes: "Adnexa Types",
  addAdnexaTypes: "add Adnexa Types",
  editAdnexaTypes: "edit Adnexa Types",
  gestationalSacTypes: "Gestational Sac Types",
  addGestationalSacTypes: "add Gestational Sac Types",
  editGestationalSacTypes: "edit Gestational Sac Types",
  gestationalLocationTypes: "Gestational Location",
  addGestationalLocationTypes: "add Gestational Location",
  editGestationalLocationTypes: "edit Gestational Location",
  yolkSacTypes: "Yolk Sac Types",
  addYolkSacTypes: "add Yolk Sac Types",
  editYolkSacTypes: "edit Yolk Sac Types",
  embryoSonographicTypes: "Embryo Sonographic",
  addEmbryoSonographicTypes: "add Embryo Sonographic",
  editEmbryoSonographicTypes: "edit Embryo Sonographic",
  bothOvariesTypes: "Both Ovaries Types",
  addBothOvariesTypes: "add Both Ovaries Types",
  editBothOvariesTypes: "edit Both Ovaries Types",
  planAndFollowUpTypes: "Plan And FollowUpTypes",
  addPlanAndFollowUpTypes: "add Plan FollowUpTypes",
  editPlanAndFollowUpTypes: "edit Plan FollowUpTypes",
  freeFluidTypes: "Free Fluid Types",
  addFreeFluidTypes: "add Free Fluid Types",
  editFreeFluidTypes: "edit Free Fluid Types",
  threeDCoronalViews: "ThreeD Coronal Views",
  addThreeDCoronalViews: "add ThreeD Coronal Views",
  editThreeDCoronalViews: "edit ThreeD Coronal Views",
  sonographyForms: "سونوگرافی",
  reports: "گزارشات",
  doctorReport: "گزارش پزشک",
  cashierReport: "گزارش صندوق",
  returnReport: "گزارش استرداد",
  functionalReports: "گزارشات عملکردی",
  financialReports: "گزارشات مالی",
  bankCards: "کارت های بانکی",
  addBankCards: "افزودن کارت های بانکی",
  editBankCards: "ویرایش کارت های بانکی",
  medicalSpecialties: "تخصص های پزشکی ",
  addMedicalSpecialties: "افزودن تخصص های پزشکی ",
  editMedicalSpecialties: "ویرایش تخصص های پزشکی ",
  permission: "دسترسی‌",
  permissions: "دسترسی‌ها",
  addPermissions: "افزودن دسترسی‌ها",
  permissionGroups: "گروه‌های دسترسی‌",
  addPermissionGroups: "افزودن گروه‌های دسترسی‌",
  medicalScientificDegrees: "درجه علمی",
  addMedicalScientificDegrees: "افزودن درجه علمی",
  editMedicalScientificDegrees: "ویرایش درجه علمی",
  banks: "بانک ها",
  addBanks: "افزودن بانک ها",
  editBanks: "ویرایش بانک ها",
  gynecology: "سلامت",
  glands: "داخلی(غدد) ",
  genetics: "ژنتیک",
  nourish: "تغذیه",
  urology: "اورولوژی",
  legal: "حقوقی",
  lab: "آزمایشگاه",
  infertility: "ناباروری",
  obstetric: "بارداری",
  serviceGroups: "دسته بندی های آزمایش",
  addServiceGroups: "افزودن دسته بندی های آزمایش",
  editServiceGroups: "ویرایش دسته بندی های آزمایش",
  monitoring: "مانیتورینگ",
  patientsMonitoring: "مانیتورینگ بیمار",
  doctorsMonitoring: "مانیتورینگ پزشک",
  countryDivisions: "تقسیمات کشوری",
  countries: "کشور ها",
  addCountries: "افزودن کشور ها",
  editCountries: "ویرایش کشور ها",
  provinces: "استان ها ",
  addProvinces: "افزودن استان ها ",
  editProvinces: "ویرایش استان ها ",
  cities: "شهرها",
  addCities: "افزودن شهرها",
  editCities: "ویرایش شهرها",
  serviceCategories: "دسته‌بندی انواع خدمت",
  addServiceCategories: "افزودن دسته‌بندی انواع خدمت",
  editServiceCategories: "ویرایش دسته‌بندی انواع خدمت",
  centralCashier: "صندوق‌دار مرکزی",
  reasonOfReferences: "دلیل ارجاعات",
  addReasonOfReferences: "افزودن دلیل ارجاعات",
  editReasonOfReferences: "ویرایش دلیل ارجاعات",
  socialNetworks: "شبکه های اجتماعی",
  addSocialNetworks: "افزودن شبکه های اجتماعی",
  editSocialNetworks: "ویرایش شبکه های اجتماعی",
  permissionRooms: "دسترسی اتاق ها",
  addPermissionRooms: "افزودن دسترسی اتاق",
  editPermissionRooms: "ویرایش دسترسی اتاق",
  permissionUnits: " دسترسی واحدها",
  addPermissionUnits: "افزودن دسترسی واحدها",
  editPermissionUnits: "ویرایش دسترسی واحدها",
  unitReport: "گزارش واحد",
  changePassword: "تغییر رمز عبور",
  sections: "بخش ها",
  units: "واحدها",
  addSection: "افزودن بخش",
  message: "پیامک",
  settings: "تنظیمات",
  calendar: "نوبت دهی بیماران",
  editMessage: "ویرایش پیام",
  addMessage:"افزودن پیام",
  AppointmentOfPatients:" لیست نوبت ها ",
  turnCounter:"پیشخوان نوبت روز",
  HolidaysMenu:"منوی تعطیلات",
  addHoliday:"افزودن تعطیلات",
  editHoliday:"ویرایش تعطیلی"
};
